import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../index.ts'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectSubmitted = ({
  activity: {
    person,
    details: {
      activityType,
      data: { project, status },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_submitted'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{
            subject: getPersonFullName(person),
            projectName: project.name,
            status: t(`${activityType}.status.${status}.text`),
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Feed.Tag type="notice">
          {t(`${activityType}.status.${status}.tag`)}
        </Feed.Tag>
        <Link
          {...{
            target: project,
            t,
            onNavigate,
            currentUrl,
          }}
        />
      </Feed.Annotations>
    </>
  )
